import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "../../components/feature/sections/HeroSection";
import TrustBar from "../../components/feature/sections/TrustBar";
import ServicesGrid from "../../components/feature/sections/ServicesGrid";
import AIAnswerBlock from "../../components/feature/sections/AIAnswerBlock";
import ProcessSection from "../../components/feature/sections/ProcessSection";
import WhyChooseUs from "../../components/feature/sections/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/sections/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/sections/TestimonialsSection";
import FAQSection from "../../components/feature/sections/FAQSection";
import FinalCTASection from "../../components/feature/sections/FinalCTASection";
import LeadFormSection from "../../components/feature/sections/LeadFormSection";
import { KRP_SERVICES, KRP_PROCESS, KRP_WHY_CHOOSE } from "../../mocks/krp-data";

const heroContent = {
  badge: "Complete Kitchen & Bath Services",
  headline: "Every Service,",
  headlineAccent: "Perfected.",
  subheadline: "Full design-build renovations for kitchens, bathrooms, cabinetry, outdoor kitchens, and more \u2014 delivered with artisan-level craft.",
  description: "Premium packages from $9,995 \u00b7 Boca Raton design center \u00b7 Serving all of South Florida",
  primaryCta: "Get a Free Estimate",
  primaryCtaPath: "/locations",
  secondaryCta: "Visit Our Showroom",
  secondaryCtaPath: "/locations",
  backgroundImage:
    "https://public.readdy.ai/ai/img_res/864201328f24132342c155225667aaef.jpg",
};

const allServicesContent = {
  badge: "Our Services",
  headline: "Signature Services by",
  headlineAccent: "KRP.",
  subtext:
    "Each KRP service is delivered with the same obsessive attention to detail, premium materials, and expert craftsmanship that has made us South Florida\u2019s most trusted design-build firm.",
  services: KRP_SERVICES,
  ctaLabel: "Start Your Project",
  ctaPath: "/locations",
};

const aiBlockContent = {
  badge: "Our Service Philosophy",
  headline: "We Don\u2019t Just Remodel. We Reimagine.",
  body:
    "At Kitchen Renovations Perfected, every service we offer is part of a complete design-build system. We handle architecture, design, permits, procurement, and installation under one roof. That means better coordination, no finger-pointing between subcontractors, and a result that\u2019s cohesive, beautiful, and built to last. Whether you\u2019re remodeling a kitchen in Boca Raton, renovating a bathroom in Delray Beach, or designing a custom outdoor kitchen in Palm Beach Gardens, KRP brings the same level of expertise and care to every project.",
  bullets: [
    "Complete design-build \u2014 one team, one vision, zero handoffs",
    "Premium materials including Fabuwood cabinetry and designer countertops",
    "Advanced 3D design visualization before construction begins",
    "Full permit management and code compliance",
    "Post-installation support and warranty coverage",
  ],
  ctaLabel: "Schedule a Consultation",
  ctaPath: "/locations",
  image1:
    "https://readdy.ai/api/search-image?query=luxury%20interior%20design%20kitchen%20showroom%20consultation%20South%20Florida%20Boca%20Raton%20cabinetry%20display%20room%20warm%20neutral%20editorial%20photography%20premium%20design%20studio%20beautiful%20samples%20on%20display%20professional%20lighting%20high%20end&width=800&height=600&seq=5020&orientation=landscape",
  image2:
    "https://readdy.ai/api/search-image?query=skilled%20craftsman%20professional%20installer%20fitting%20premium%20kitchen%20cabinetry%20precision%20work%20high%20end%20South%20Florida%20home%20renovation%20craftsmanship%20detail%20photography%20warm%20neutral%20background%20quality%20construction&width=600&height=450&seq=5030&orientation=landscape",
};

const processContent = {
  badge: "How It Works",
  headline: "From Vision to",
  headlineAccent: "Reality.",
  subtext: "Our five-step process ensures your renovation is stress-free, on-budget, and delivered to the exact standard you deserve.",
  steps: KRP_PROCESS,
};

const whyUsContent = {
  badge: "The KRP Difference",
  headline: "Why South Florida Chooses",
  headlineAccent: "KRP.",
  subtext:
    "A 4.9-star rating built on transparency, superior craftsmanship, and a family-owned ethos that treats your home like our own.",
  reasons: KRP_WHY_CHOOSE,
  ctaLabel: "Meet The Team",
  ctaPath: "/about",
};

const areasContent = {
  badge: "Where We Work",
  headline: "Serving South Florida\u2019s Most Prestigious Communities",
  body:
    "From Palm Beach County to Broward County, KRP brings premium kitchen and bath design to homeowners throughout South Florida. Our Boca Raton showroom is your starting point for any renovation project.",
  ctaLabel: "Find Your Area",
  ctaPath: "/locations",
};

const testimonialsContent = {
  badge: "What Clients Say",
  headline: "South Florida Homeowners Love KRP.",
  subtext: "Real testimonials from real clients who transformed their homes with Kitchen Renovations Perfected.",
};

const faqContent = {
  badge: "Service Questions",
  headline: "Your Service Questions, Answered.",
  subtext: "Everything you need to know about our renovation services, process, and pricing.",
  faqs: [
    {
      question: "What services does Kitchen Renovations Perfected offer?",
      answer:
        "KRP offers a complete suite of home renovation services including kitchen remodeling, bathroom renovations, custom cabinetry design and installation, outdoor kitchens, custom closets, and premium flooring installation. We operate as a full design-build firm across all of South Florida.",
    },
    {
      question: "Do you handle the entire renovation from design to installation?",
      answer:
        "Yes. KRP is a complete design-build firm, meaning we handle everything from initial consultation and 3D design through material procurement, permit management, construction, and final installation. You never need to coordinate multiple contractors.",
    },
    {
      question: "How do I know what materials are best for my kitchen?",
      answer:
        "Our expert design team will guide you through every material decision during your showroom visit and consultation. We work with premium brands and will recommend options that match your lifestyle, aesthetic preferences, and investment range.",
    },
    {
      question: "Can I see examples of your completed kitchen projects?",
      answer:
        "Absolutely. Visit our Boca Raton showroom to view project portfolios and material samples, or ask your KRP designer to share completed project examples relevant to your style preferences during your consultation.",
    },
    {
      question: "Do you offer outdoor kitchen design in South Florida?",
      answer:
        "Yes. KRP specializes in outdoor kitchen design and construction built specifically for Florida\u2019s year-round outdoor lifestyle. We design fully equipped outdoor cooking and entertainment spaces using weather-resistant materials selected for the South Florida climate.",
    },
  ],
};

const finalCTAContent = {
  badge: "Begin Your Renovation",
  headline: "The Kitchen You\u2019ve",
  headlineAccent: "Always Imagined.",
  description:
    "Our design team is ready to help you build it. Start with a free, no-obligation consultation at our Boca Raton showroom or in your home.",
  primaryCta: "Request Free Consultation",
  primaryCtaPath: "/locations",
  secondaryCta: "Call (561) 441-6008",
  secondaryCtaHref: "tel:5614416008",
  backgroundImage:
    "https://readdy.ai/api/search-image?query=stunning%20luxury%20kitchen%20renovation%20complete%20transformation%20warm%20ivory%20soft%20white%20cabinetry%20dramatic%20marble%20backsplash%20quartz%20waterfall%20island%20antique%20brass%20hardware%20pendants%20statement%20range%20South%20Florida%20luxury%20residence%20professional%20architectural%20photography%20warm%20cinematic%20editorial%20high%20end&width=1600&height=1000&seq=5040&orientation=landscape",
};

export default function ServicesPage() {
  return (
    <main>
      <Navbar />
      <HeroSection content={heroContent} />
      <TrustBar />
      <ServicesGrid content={allServicesContent} />
      <AIAnswerBlock content={aiBlockContent} />
      <ProcessSection content={processContent} />
      <WhyChooseUs content={whyUsContent} />
      <ServiceAreasSection content={areasContent} />
      <TestimonialsSection content={testimonialsContent} />
      <FAQSection content={faqContent} />
      <LeadFormSection variant="dark" />
      <FinalCTASection content={finalCTAContent} />
      <Footer />
    </main>
  );
}
